import { Component, EventEmitter, Output, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule, MatDialog } from '@angular/material/dialog';
import { MatChipsModule } from '@angular/material/chips';
import { DynamicFormsV2Component } from '../dynamic-forms-v2/dynamic-forms-v2.component';
import { GroupField, formMetaData } from '../dynamic-forms.interface2';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-date-filter',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatDialogModule,
    MatChipsModule,
    DatePipe
  ],
  templateUrl: './date-filter.component.html',
  styleUrls: ['./date-filter.component.scss']
})
export class DateFilterComponent {
  @Output() dateChange = new EventEmitter<{ start: string | null, end: string | null }>();

  private dialog = inject(MatDialog);

  activeStart: string | null = null;
  activeEnd: string | null = null;

  openFilterDialog() {
    const dateGroupField: GroupField = {
      generalProperties: {
        fieldName: 'Date Filter',
        fieldApiName: 'dateFilter',
        isGroup: true,
        isArray: false,
        fieldType: 'IndividualField',
        groupFieldsHint: 'Select the start and end dates to filter encounters.',
      },
      groupFields: {
        start: {
          generalProperties: {
            fieldName: 'Start Date',
            fieldApiName: 'start',
            inputType: 'datetime-local',
            isGroup: false,
            isArray: false,
            fieldType: 'IndividualField'
          },
          data: '',
          dataType: 'string'
        },
        end: {
          generalProperties: {
            fieldName: 'End Date',
            fieldApiName: 'end',
            inputType: 'datetime-local',
            isGroup: false,
            isArray: false,
            fieldType: 'IndividualField'
          },
          data: '',
          dataType: 'string'
        }
      },
      keys: ['start', 'end']
    };
    
    const formMetaData: formMetaData = {
      formName: 'Filter by Date',
      formDescription: 'Choose a date range to apply as a filter.',
      submitText: 'Apply Filter',
      closeDialogOnSubmit: true,
      showSubmitButton: true
    };

    const dialogRef = this.dialog.open(DynamicFormsV2Component, {
      width: '500px',
      data: {
        formMetaData,
        formFields: [dateGroupField],
        prepopulatedData: {
          dateFilter: {
            start: this.activeStart ? this.activeStart.split('T')[0] : null,
            end: this.activeEnd ? this.activeEnd.split('T')[0] : null
          }
        }
      }
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result && result.values && result.values.dateFilter) {
        const startVal = result.values.dateFilter.start;
        const endVal = result.values.dateFilter.end;
        
        // Add time components to make them ISO strings if provided, else null
        this.activeStart = startVal ? new Date(startVal).toISOString() : null;
        this.activeEnd = endVal ? new Date(endVal).toISOString() : null;

        this.dateChange.emit({
          start: this.activeStart,
          end: this.activeEnd
        });
      }
    });
  }

  clearFilter() {
    this.activeStart = null;
    this.activeEnd = null;
    this.dateChange.emit({ start: null, end: null });
  }
}
